<template>
  <b-card no-body class="h-100">
    <b-card-header class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="card-title mb-0">Status Operacional</h4>
        <small class="text-muted">{{ data.totalOrders }} Ordens</small>
      </div>
    </b-card-header>
    <b-card-body>
      <!-- Stacked Progress Bar -->
      <div class="progress-wrapper mb-2">
        <b-progress class="mt-1" height="15px">
          <b-progress-bar v-for="(item, index) in data.distribution" :key="index" :value="item.value"
            :style="{ backgroundColor: item.color }"></b-progress-bar>
        </b-progress>
      </div>

      <!-- Legend Grid -->
      <div class="legend-grid mt-3">
        <div v-for="(item, index) in data.distribution" :key="index" class="legend-item mb-2">
          <div class="d-flex align-items-center mb-1">
            <div class="indicator" :style="{ backgroundColor: item.color }"></div>
            <span class="legend-label text-truncate" :title="item.label">{{ item.label }}</span>
          </div>
          <div class="legend-value font-weight-bold">{{ item.value }}%</div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BProgress, BProgressBar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BProgress,
    BProgressBar
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.legend-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.indicator {
  width: 4px;
  height: 12px;
  margin-right: 6px;
  border-radius: 2px;
}

.legend-label {
  font-size: 0.85rem;
  color: #6e6b7b;
}

.legend-value {
  font-size: 0.9rem;
  padding-left: 10px;
}
</style>
